import React, { useState, useMemo, useRef } from "react";
import { Box, Typography, Stack, Button, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import { useQueryClient } from "@tanstack/react-query";

import { CardDesign } from "./UserViewCardDesign";
import {
  useGetAllCard,
  useBookmarkCard,
  useGetCategories,
  useAddToDeckCard,
} from "../../../../../services/api/card.api";
import { useCardStore } from "../../../../../services/store/UseCardStore";
import {
  useGetBookmarkedCards,
  useGetAddedToDeckCards,
} from "../../../../../services/api/booking.api";
import { CardFormValues } from "../../../../../types/Card";
import SubCategories from "./SubCategories";
import Categories from "./Categories";
import GuestSignInModal from "../../../../../pages/Auth/GuestSignInModal";
import { useAuth } from "../../../../../hooks";
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";


const RenderCategories = ({
}) => {


  const { data: category } = useGetCategories({ key: ["categories"] });
  const categoryData = category?.data || [];

  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const [selectedSubCategories, setSelectedSubCategories] = useState<string[]>(
    []
  );

  const scrollRef = useRef<HTMLDivElement>(null);

  const scrollBy = (offset: number) => {
    scrollRef.current?.scrollBy({ left: offset, behavior: "smooth" });
  };

  const handleCategoryClick = (slug: string) => {
    const isSameCategory = selectedCategory === slug;
    setSelectedCategory(isSameCategory ? null : slug);
    setSelectedSubCategories([]);
  };

  const handleSubCategoryClick = (slug: string) => {
    setSelectedSubCategories((prev) =>
      prev.includes(slug) ? prev.filter((s) => s !== slug) : [...prev, slug]
    );
  };




  return (
    <Box sx={{ mb: 6, mt: 3 }}>

      <Categories
        handleCategoryClick={handleCategoryClick}
        categoryData={categoryData}
        selectedCategory={selectedCategory}
      />
      {selectedCategory && (
        <SubCategories
          categoryData={categoryData}
          selectedCategory={selectedCategory}
          selectedSubCategories={selectedSubCategories}
          handleSubCategoryClick={handleSubCategoryClick}
        />
      )}

     


    </Box>
  );
};

export default RenderCategories;
